import { Box, Chip, List, ListItem, ListItemText, Typography } from '@mui/material';

export const AuctionRanking = ({ ranking = [], variant = 'anon', FormatPrice }) => {
  if (!ranking.length) {
    return (
      <Typography variant="caption" color="text.secondary">
        Aún no hay pujas. El hero muestra el valor de apertura.
      </Typography>
    );
  }

  return (
    <List dense disablePadding>
      {ranking.slice(0, 5).map((row) => (
        <ListItem
          key={row.cod_bid}
          sx={{
            borderColor: 'divider',
            borderBottom: '1px solid',
            bgcolor: row.self ? 'successContainer.main' : 'background.paper',
            px: 1,
          }}
        >
          <Chip size="small" label={row.puesto} sx={{ mr: 1, flexShrink: 0 }} />
          <ListItemText
            primary={`$ ${FormatPrice(row.valor)}`}
            secondary={
              variant === 'buyer'
                ? `${row.proveedor || row.etiqueta || 'Otro'}${row.usuario ? ` · ${row.usuario}` : ''}${row.celular ? ` · ${row.celular}` : ''}`
                : row.etiqueta
            }
            primaryTypographyProps={{ variant: 'subtitle2' }}
            secondaryTypographyProps={{ variant: 'caption' }}
          />
          {row.self && <Chip size="small" color="success" label="Tú" />}
        </ListItem>
      ))}
      {ranking.length > 5 && (
        <Box sx={{ pt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            +{ranking.length - 5} ofertas fuera del top 5
          </Typography>
        </Box>
      )}
    </List>
  );
};
